import { FetchFilters } from "../../Services/MainServices";

export const SET_FILTER = "SET_FILTER";
export const RESET_FILTERS = "RESET_FILTERS";
export const SET_SEARCH_TERM = "SET_SEARCH_TERM";
export const FETCH_FILTERS_REQUEST = "FETCH_FILTERS_REQUEST";
export const FETCH_FILTERS_SUCCESS = "FETCH_FILTERS_SUCCESS";
export const FETCH_FILTERS_FAILURE = "FETCH_FILTERS_FAILURE";

// Thunk: fetch all available filter options (categories, subcategories, sizes, colors, tags)
export const fetchFilters = (payload) => async (dispatch) => {
  dispatch({ type: FETCH_FILTERS_REQUEST });
  try {
    const response = await FetchFilters(payload);
    // The endpoint returns { status, message, data: { categories, subcategories, sizes, colors, tags } }
    dispatch({
      type: FETCH_FILTERS_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_FILTERS_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const setFilter = (filterType, value) => (dispatch, getState) => {
  const { auth } = getState();
  const isAuthenticated = auth?.isAuthenticated;

  dispatch({
    type: SET_FILTER,
    payload: { filterType, value, isAuthenticated },
  });
};

export const resetFilters = () => ({
  type: RESET_FILTERS,
});

export const updateSearchTerm = (search) => ({
  type: SET_SEARCH_TERM,
  payload: search,
});
